import React from 'react';
import NavItem from 'components/sidebar/NavItem';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import { withRouter } from 'react-router';
import {
  useGetSelectedTargetCharts,
  useIsWellDropOrXtalSearch,
  useSearchResult,
} from 'redux/hooks/searchnFilter';
import { BooleanPropertyDTO } from 'business/models/Models';
import { PropertyConstants } from 'enums/PropertyConstants';
import { useSystemProperty } from 'CustomHooks/useSystemProperty';

const iconColor = '#fff';

interface Props {
  to: string;
}

const Sidebar = (props: Props) => {
  const { to } = props;
  const searchResults = useSearchResult();
  const enableCanvasPref = useSystemProperty(
    PropertyConstants.SeachFilterEnableCanvas,
    false,
  );
  const isCanvasEnabled = (enableCanvasPref as BooleanPropertyDTO)?.value !== false;
  const isWellDropOrXtalSearch = useIsWellDropOrXtalSearch();
  const isDisableCanvasRoutes =
    !isCanvasEnabled || !isWellDropOrXtalSearch || searchResults.rows.items.length == 0;
  const selectedTargetCharts = useGetSelectedTargetCharts();

  return (
    <div
      id="searchandfilter-index-sidebar-wrapper"
      className="sidebar border-sidebar h-100"
    >
      <NavItem
        to={`/snf/${to}`}
        label="Info"
        key="index"
        isDisabled={false}
        icon={<RMSvgIcon id="searchandfilter-svg-info-icon" name="SearchandFilterInfo" />}
      />
      <NavItem
        to={`/snf/${to}/result`}
        label="Result"
        key="result"
        icon={
          <RMSvgIcon id="searchandfilter-svg-result-icon" name="SearchandFilterResult" />
        }
      />
      {isCanvasEnabled && (
        <>
          <NavItem
            to={`/snf/${to}/canvas`}
            label="Canvas"
            key="canvas"
            isDisabled={isDisableCanvasRoutes}
            icon={
              <RMSvgIcon
                id="searchandfilter-svg-canvas-icon"
                name="SearchandFilterCanvas"
              />
            }
          />
          <NavItem
            to={`/snf/${to}/drop`}
            label="Drop"
            key="drop"
            isDisabled={isDisableCanvasRoutes}
            icon={<RMSvgIcon id="searchandfilter-svg-drop-icon" name="Drop" />}
          />
          <NavItem
            to={`/snf/${to}/compare`}
            label="Compare"
            key="compare"
            isDisabled={isDisableCanvasRoutes}
            icon={
              <RMSvgIcon
                id="searchandfilter-svg-compare-icon"
                name="Compare"
                fill={iconColor}
              />
            }
          />
        </>
      )}
      <NavItem
        to={`/snf/${to}/analytics`}
        label="Graph"
        key="analytics"
        isDisabled={!selectedTargetCharts?.length || searchResults.rows.items.length == 0}
        icon={
          <RMSvgIcon id="searchandfilter-svg-graph-icon" name="Graph" fill={iconColor} />
        }
      />
    </div>
  );
};

export default withRouter(Sidebar);
